import type { MarkThreadDto, ReviewSetDto } from '@nsb/core';
import { MarkupTools, Thread } from '../../components/Markup.tsx';
import { Button } from '../../components/ui.tsx';
import { IterationHead } from './IterationHead.tsx';

/** The button a reviewer presses once they have been through it, and the help's step that names it. */
export const DONE_WORDS = 'I’m done reviewing';

/*
 * The examples beside the client's how-to (Title how, examples; B44): the real pieces, fed a small example as the
 * Introduction's drawings are (Jason, 2026-10-06: "don't just invent shit that looks good"): the iteration's row as the
 * list draws it, the markup page's own tools, a numbered mark's thread as the markup page draws it, and the button a
 * reviewer presses. Only the words and the day are the example's. None of it can be pressed (inert).
 */

/** An iteration NSB shared for review, as the client reads it. */
export const EXAMPLE_ITERATION: ReviewSetDto = {
  id: 'example',
  phase: 'Design',
  iteration: 1,
  title: 'Concept',
  note: null,
  sharedAt: '2026-10-06T16:00:00Z',
  sharedBy: 'Test Jason',
  task: null,
  stepGone: null,
  files: [],
  reviewers: [],
  reviewed: false,
  yours: 'waiting',
  comments: [],
  summary: null,
  reopened: null,
  reached: true,
  createdAt: '2026-10-06T15:00:00Z',
};

/** The reader's own comment where they pressed, numbered in its iteration. */
export const EXAMPLE_THREAD: MarkThreadDto = {
  threadId: 'example',
  number: 1,
  resolved: false,
  resolvedBy: null,
  resolvedAt: null,
  root: {
    id: 'example',
    markId: 'example',
    threadId: 'example',
    version: 1,
    authorName: 'You',
    authorRole: 'client',
    mine: true,
    shape: null,
    body: 'Your comment, where you pressed.',
    withdrawn: false,
    createdAt: '2026-10-06T19:04:00Z',
  },
  replies: [],
};

const none = () => undefined;

/** The four steps' pictures, in their order. */
export function reviewExamples() {
  return [
    <div key="open" inert className="w-full max-w-[22rem] border-y border-rule py-3">
      <IterationHead set={EXAMPLE_ITERATION} staff={false} />
    </div>,
    <div key="tools" inert>
      <MarkupTools active="pin" />
    </div>,
    <ul key="thread" inert className="w-full max-w-[22rem]">
      <Thread projectId="example" fileId="example" thread={EXAMPLE_THREAD} canResolve={false} locked={false} selected={false} onSelect={none} onChange={none} />
    </ul>,
    <div key="done" inert>
      <Button>{DONE_WORDS}</Button>
    </div>,
  ];
}
